import { render } from "./VideoRecommendations.vue?vue&type=template&id=38de0428&scoped=true"
import script from "./VideoRecommendations.vue?vue&type=script&lang=js"
export * from "./VideoRecommendations.vue?vue&type=script&lang=js"

import "./VideoRecommendations.vue?vue&type=style&index=0&id=38de0428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38de0428"]])

export default __exports__